import React from "react";
import { formatToCurrencyString } from "../../../../../../helpers";
import CopyAccountNumber from "../../../../../System/CopyAccountNumber";
import ShowAndHide from "../../../../../System/FormComponents/ShowAndHide";

const SepaBibDetails = ({ showDetail = true, showId, sepa }: any) => {
  return (
    <ShowAndHide show={showDetail}>
      <div className="flex flex-col text-base mt-4">
        {showId && (
          <div className="flex flex-col mb-2">
            <span>
              ID:{" "}
              <b>
                {sepa?.id} <CopyAccountNumber number={sepa?.id} />
              </b>
            </span>
          </div>
        )}

        <div className="flex flex-col mb-2">
          <span>
            Amount:{" "}
            <b>
              {formatToCurrencyString(
                sepa?.amount || 0,
                sepa?.counterparty?.currency
              )}
            </b>
          </span>
        </div>

        <div className="flex flex-col mb-2">
          <span>
            From: <b>{sepa?.payer?.account}</b>
          </span>
        </div>

        <div className="flex flex-col mb-2">
          <span>
            To:{" "}
            <b>
              {sepa?.counterparty?.account}, {sepa?.counterparty?.name}
            </b>
          </span>
        </div>

        <div className="flex flex-col mb-2">
          <span>
            Comment: <b>{sepa?.details}</b>
          </span>
        </div>
      </div>
    </ShowAndHide>
  );
};

export default SepaBibDetails;
